var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircleFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85483 0.25C8.08197 0.25 6.34893 0.821828 4.87486 1.89317C3.40078 2.96451 2.25188 4.48726 1.57344 6.26884C0.894997 8.05042 0.717486 10.0108 1.06335 11.9021C1.40922 13.7934 2.26293 15.5307 3.51653 16.8943C4.77013 18.2579 6.36731 19.1865 8.1061 19.5627C9.84489 19.9389 11.6472 19.7458 13.2851 19.0078C14.923 18.2699 16.3229 17.0202 17.3079 15.4168C18.2928 13.8134 18.8185 11.9284 18.8185 10C18.814 7.41566 17.8681 4.93859 16.1881 3.11118C14.5081 1.28378 12.2308 0.254956 9.85483 0.25ZM13.3024 10.75H6.40725C6.22438 10.75 6.049 10.671 5.91969 10.5303C5.79038 10.3897 5.71773 10.1989 5.71773 10C5.71773 9.80109 5.79038 9.61032 5.91969 9.46967C6.049 9.32902 6.22438 9.25 6.40725 9.25H13.3024C13.4853 9.25 13.6607 9.32902 13.79 9.46967C13.9193 9.61032 13.9919 9.80109 13.9919 10C13.9919 10.1989 13.9193 10.3897 13.79 10.5303C13.6607 10.671 13.4853 10.75 13.3024 10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleFilledIcon);
export default __webpack_public_path__ + "static/media/minus-circle-filled-icon.a4fc4be7a1b2fc9d1a07b3ad9241da63.svg";
export { ForwardRef as ReactComponent };